import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { PageHeader, Skeleton } from 'antd';
import { useHistory, useParams } from 'react-router-dom';
import { T } from 'react-translator-component';
import styled from 'styled-components';

import { getOcppTagsCards } from '../../hooks/ocpptags';
import { getTenants } from '../../hooks/tenants';
import {
  getUserAddress,
  getUserDetail,
  getUserGroups,
} from '../../hooks/users';
import UserConfigForm from '../organisms/UserForm/UserConfigForm';
import { getCompanies } from '../../hooks/company';
import { connect } from 'react-redux';

const UserEditPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0;

  h1 {
    font-size: 24px;
  }
`;

const UserEditPage = (chargePointsList) => {
  const { id } = useParams();
  const [userDetail, setUserDetail] = useState(null);
  const [tenants, setTenants] = useState({});
  const [userGroups, setUserGroups] = useState({});
  const [userAddress, setUserAddress] = useState(null);
  const [ocppTagCards, setOcppTagCards] = useState(null);
  const [companiesList, setCompaniesList] = useState(null);
  const [company, setCompany] = useState(null);

  const history = useHistory();

  const getCompaniesData = useCallback(async () => {
    const companiesData = await getCompanies();

    setCompaniesList(companiesData.companyList);
  }, []);

  useEffect(() => {
    (async function () {
      setUserDetail(await getUserDetail(id));
      setTenants(await getTenants(id));
      setUserGroups(await getUserGroups(id));
      setUserAddress(await getUserAddress(id));
      setOcppTagCards(await getOcppTagsCards('CARD', id));
    })();
  }, [id]);

  useEffect(() => {
    (async function () {
      await getCompaniesData();
    })();
  }, []);

  useEffect(() => {
    if (
      companiesList &&
      userDetail &&
      userDetail.userForm &&
      userDetail.userForm.company_uuid
    ) {
      const foundCompany = companiesList.find(
        (item) => item.uuid === userDetail.userForm.company_uuid,
      );

      if (foundCompany) {
        setCompany(foundCompany);
      }
    }
  }, [companiesList, userDetail]);

  if (userDetail === null || userAddress === null || ocppTagCards === null)
    return (
      <UserEditPageWrapper>
        <Skeleton active />
      </UserEditPageWrapper>
    );

  if (userDetail?.error)
    return (
      <UserEditPageWrapper>
        <p>Nenhum usuário encontrada com este id.</p>
      </UserEditPageWrapper>
    );

  function mapOcppTags(tags) {
    if (tags.length) {
      return tags
        .filter(
          (ocppTag) =>
            ocppTag.parentUserPk === null || ocppTag.parentUserPk == id,
        )
        .map((ocppTag) => {
          return {
            key: ocppTag.ocppTagPk,
            title: ocppTag.idTag,
          };
        });
    }
  }

  function mapTargetOcppTags(tags) {
    if (tags != null) {
      return tags;
    }
  }

  const {
    email,
    firstName,
    lastName,
    dateBirthDay,
    ocppIdTag,
    phone,
    activeUser,
    notificationOfflineCp,
    docType,
    docNumber,
    externalId,
    ocppTags,
    sex,
    userGroupPk,
    tenant_pk,
    allowed_chargeboxes,
    uuid,
    skipThreeDSVerification,
  } = userDetail.userForm;

  const availableOcppTagList = ocppTagCards.ocppTagList;

  const isVehicle = history.location.state?.isVehicle;

  const {
    addressForm: {
      addressPk,
      city,
      houseNumber,
      state,
      street,
      zipCode,
      block,
      apartment,
      complement,
      district,
      cityNumber,
    },
  } = userAddress;

  const initialValues = {
    addressPk,
    email,
    firstName,
    lastName,
    dateBirthDay,
    ocppIdTag,
    phone,
    addressPk,
    district,
    complement,
    city,
    country: 'BR',
    houseNumber,
    cityNumber,
    state,
    street,
    zipCode,
    block,
    apartment,
    activeUser,
    notificationOfflineCp,
    docType,
    docNumber,
    externalId,
    ocppTags,
    sex,
    userGroupPk,
    tenant_pk,
    company,
    uuid,
    skipThreeDSVerification,
  };

  return (
    <UserEditPageWrapper>
      <PageHeader
        className='site-page-header'
        onBack={() => history.goBack()}
        title={isVehicle ? T('Editing Vehicle') : T('Editing User')}
        subTitle={`${firstName}`}
      />
      <UserConfigForm
        initialValues={initialValues}
        type='update'
        tenants={tenants}
        userGroups={userGroups}
        userPk={id}
        availableOcppTags={mapOcppTags(availableOcppTagList)}
        targetOcppTags={mapTargetOcppTags(ocppTags)}
        isVehicle={isVehicle}
        companiesList={companiesList}
        chargePointsList={chargePointsList}
        getCompaniesData={getCompaniesData}
        isPagBank={userDetail.isPagBank}
        targetChargeboxes={(chargePointsList?.chargePointsList || [])
          .filter((chargePoint) =>
            (allowed_chargeboxes || [])?.includes(chargePoint?.chargeBoxId),
          )
          .map((chargePoint) => chargePoint?.chargeBoxId)}
      />
    </UserEditPageWrapper>
  );
};

const mapStateToProps = (state) => ({
  chargePointsList: state.chargePoints.chargePoints.chargePointList,
});

export default connect(mapStateToProps)(UserEditPage);
